import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_COMPONENT_CREATE_REQUEST_STATUS_COUNTS } from '@api/queries/components';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';

export interface UseComponentCreateRequestStatusCounts {
    total: number;
    byStatus: Record<ComponentCreateRequestStatusCode, number>;
}

const toCount = (connection?: { totalCount: number }): number =>
    connection?.totalCount ?? 0;

export function useComponentCreateRequestStatusCounts(): UseComponentCreateRequestStatusCounts {
    const { data } = useQuery(GET_COMPONENT_CREATE_REQUEST_STATUS_COUNTS);

    // The Record type makes a new status code fail to compile here.
    return useMemo(
        () => ({
            total: toCount(data?.total),
            byStatus: {
                [ComponentCreateRequestStatusCode.Created]: toCount(
                    data?.created,
                ),
                [ComponentCreateRequestStatusCode.ApprovalPending]: toCount(
                    data?.approvalPending,
                ),
                [ComponentCreateRequestStatusCode.Approved]: toCount(
                    data?.approved,
                ),
                [ComponentCreateRequestStatusCode.Forwarded]: toCount(
                    data?.forwarded,
                ),
                [ComponentCreateRequestStatusCode.Replaced]: toCount(
                    data?.replaced,
                ),
                [ComponentCreateRequestStatusCode.Removed]: toCount(
                    data?.removed,
                ),
            },
        }),
        [data],
    );
}
